import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {ExcelService} from "./excel.service";
import {NzMessageService} from 'ng-zorro-antd';
import {CommonsService} from '@core/service/commons.service';

/**
 * excel导入
 */
@Component({
  selector: 'excel-input',
  templateUrl: './excel-input.component.html',
})

export class ExcelInputComponent implements OnInit {
  @Input() isVisible:boolean;
  @Output() isVisibleChange = new EventEmitter();
  /**
   * 导入成功事件
   * @type {EventEmitter}
   */
  @Output() inputSuccess = new EventEmitter();
  @Input() excelUrl:string;
  @Input() templateName:string;
  @Input() excelTitle:string;

  excelErrorList:any[] = [];
  fileList:any[] = [];

  ngOnInit():void {
  }

  beforeUpload = (file:File) => {
    if(file.type){
      const allowType = ((file.type === 'application/vnd.ms-excel') ||
        (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'));
      if (!allowType) {
        this.message.error(this.commonsService.translate('shared.excel.notAllow'));
        return false;
      }
    }else if(file.name){
      let fileType = file.name.split('.')[file.name.split('.').length - 1];
      if(fileType != 'xls' && fileType != 'xlsx'){
        this.message.error(this.commonsService.translate('shared.excel.notAllow'));
        return false;
      }
    }
  };

  constructor(private excelService:ExcelService,
              private commonsService:CommonsService,
              private message:NzMessageService) {
  }

  handleChange(info:any):void {
    if (info.file.response) {
      let result = info.file.response;
      this.excelErrorList = result.data;
      if("error" == result.status){
        this.excelError(this.excelErrorList);
      }else{
        this.excelSuccess(this.excelErrorList);
      }
    }
  }

  excelSuccess(excelErrorList){
    this.message.success(this.commonsService.translate('shared.excel.importSucceed'));
    this.fileList = [];
    this.inputSuccess.emit(excelErrorList);
    this.handleCancel();

  }

  excelError(excelErrorList){
    if (this.excelErrorList.length == 0) {
      this.message.success(this.commonsService.translate('shared.excel.importSucceed'));
      this.fileList = [];
      this.inputSuccess.emit(true);
      this.handleCancel();
    } else {
      this.message.error(this.commonsService.translate('shared.excel.importFail'));
      this.fileList = [];
    }

  }

  /**
   * 关闭
   */
  handleCancel():void {
    this.isVisible = false;
    this.fileList = [];
    this.excelErrorList = [];
    this.isVisibleChange.emit(false);
  }
}
